
import { defineAsyncComponent, defineComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';
import RequiredInputsPayload from '@/models/RequiredInputsPayloadModel';
import Button from '@/models/ButtonModel';
import api from '@/api';
import RequitedControl from '@/models/RequiredControl';
import SelectChanelTrigger from '@/components/MessageTypes/SelectChanelRefactor/SelectChanelTrigger.vue';

export default defineComponent({
	name: 'SelectChanelRefactor',
	components: {
		SelectChanelTrigger,
		widget: defineAsyncComponent(
			() =>
				import('@/components/MessageTypes/SelectChanelRefactor/SelectChanelWidget.vue')
		),
		trigger: SelectChanelTrigger
	},
	props: {
		// Определение типа компонента
		displayType: {
			type: String,
			required: true
		},
		// Текущее сообщение
		message: {
			type: Object as PropType<Message>
		},
		// Является ли данное сообщение последним
		isLastMessage: {
			type: Boolean
		},
		// Отображать ли хвост сообщения
		isShowMessageTail: {
			type: Boolean
		},
		// Аватарка
		avatar: {
			type: String
		},
		respondentId: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			showInvalidRequiredInputs: false,
			requiredFieldsPayload: {} as RequiredInputsPayload,
			requiredInputsData: {} // Объект с данными об обязательных полях которые нужно отрисовать
		};
	},
	computed: {
		// Проверка валидации обязательных полей
		isValidRequiredInputs(): boolean {
			let isValid = true;
			Object.keys(this.requiredInputsData).forEach((inputType) => {
				const control = this.requiredInputsData[inputType];
				// валидны если текущий контрол валиден и доэтого состояние было валидно
				isValid = control.isValid && isValid;
				// записываем значение инпутов для отправки данных на сервер
				this.requiredFieldsPayload[inputType] = control.value;
			});
			return isValid;
		},
		// Разделение кнопок на обычные и кнопки выбора канала
		separationButtons() {
			const selectChannelButtons: Button[] = [];
			const commonButtons: Button[] = [];
			this.message?.buttons?.forEach((button) => {
				if (button.params.provider) {
					selectChannelButtons.push(button);
					return;
				}
				commonButtons.push(button);
			});
			return { selectChannelButtons, commonButtons };
		}
	},
	methods: {
		clickOnButton(button: Button) {
			// Проверяем валидацию полей
			if (!this.isValidRequiredInputs) {
				// Показываем ошибки в невалидных инпутах
				this.showInvalidRequiredInputs = true;
				return;
			}
			if (button.link) {
				// Открываем переход к соц сети в попапе
				window.open(button.link, '_blank');
			}

			if (this.message?.required_inputs?.length) {
				this.postRequiredInputs();
			}

			const text = button.command ?? button.text;
			const type = button.command ? 'command' : 'text-my';

			const payload = {
				text,
				textBody: button.text,
				params: button.params,
				type,
				buttonType: button.type
			};

			this.$emit('send-message', payload);
		},
		// Функция отправляет значения инпутов на сервер
		postRequiredInputs() {
			api.sendRequiredInputs(this.respondentId, this.requiredFieldsPayload);
		},
		// Изменение значения инпутв
		changeControl(control: RequitedControl) {
			this.requiredInputsData[control.type] = {
				value: control.value,
				isValid: control.isValid
			};
		}
	},
	mounted() {
		this.$emit('init');
		// если в сообщение есть обязательные поля
		if (this.message?.required_inputs?.length) {
			// Заполняем объект для отрисовки обязательных полей устанавливаем значени по умолчанию
			this.message.required_inputs.forEach((input) => {
				this.requiredInputsData[input.type] = { isValid: false, value: '' };
			});
		}
	}
});
